export class ChallengeConfirmationError extends Error {
  name = 'AUTH_CHALLENGE_CONFIRMATION_ERROR';
}

export function isChallengeConfirmationError(
  error: Error
): error is ChallengeConfirmationError {
  return error.name === 'AUTH_CHALLENGE_CONFIRMATION_ERROR';
}
